import { IconButton, IconButtonProps } from "@chakra-ui/react";
import { FaTrashAlt } from "react-icons/fa";

export const TrashButton = (
  props: Omit<IconButtonProps, "aria-label"> & { "aria-label"?: string }
) => {
  return (
    <IconButton
      aria-label="Remove Shift"
      colorScheme="red"
      icon={<FaTrashAlt />}
      variant="ghost"
      {...props}
    />
  );
};
